import { Media } from '@doordash/design-language'
import styled from 'styled-components'

const ResponsiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.Mobile`
    justify-content: space-between;
    min-height: calc(100vh - 105px);
  `}
`
export default ResponsiveWrapper
